import { inject, Injectable } from '@angular/core';

import { SkillsIdeateCacheService } from '@core/tellent-skills-logic';
import { SkillsIdeateStepDefinition } from '@core/tellent-skills-types';

@Injectable({ providedIn: 'root' })
export class SkillsIdeateFlowStepService {
  private readonly cacheService = inject(SkillsIdeateCacheService);

  public readonly flowSteps: SkillsIdeateStepDefinition[] = [
    {
      step: 'intro',
      canMatch: () => !this.cacheService.getDontShowIntroFlag(),
    },
    { step: 'generate_options' },
    {
      step: 'loading',
      canMatch: data => !data.resultJson && !data.error,
    },
    {
      step: 'result',
      canMatch: data => !data.error,
    },
    {
      step: 'result_error',
      canMatch: data => !!data.error,
    },
  ];
}
